import TabPane from './tab-pane.vue'

TabPane.install = function (Vue) {
  Vue.component(TabPane.name, TabPane);
};
export default TabPane



// WEBPACK FOOTER //
// ./src/ni-ui/tabs/tab-pane/index.js